export default __webpack_public_path__ + "static/media/pdf_fp_bg.32155e2b.png";